export default "__VITE_ASSET__Bv9F2aNA__"